import React from 'react';
import { InputAdornment } from '@material-ui/core';

function Adornment(props) {
  return <InputAdornment {...props} className="action" />;
}

export default Adornment;
